import {
  Box, Flex, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Td, Text,
  Tr,
} from "@chakra-ui/react"
import GuestAvatar from "components/elements/GuestAvatar"
import React from "react"
import { firstName, lastName } from "utilities/strings"
import { useCurrentEvent } from "queries/events"
import { SubmissionResponseType } from "sharedTypes"
import { useHistory, useLocation } from "react-router-dom"
import { eventPath } from "utilities/routes"
import Response from "./Response"

type Props = {
  guestId: string
  name: string
  photoUrl: string
  email: string
  response: SubmissionResponseType
}

const ResponseListItem = ({
  guestId, name, photoUrl, email, response,
}: Props) => {
  const { data: { id: eventId } } = useCurrentEvent()
  const history = useHistory()
  const location = useLocation()

  const handleClickGuest = () => history.push({
    pathname: `${eventPath(eventId)}/guests/${guestId}`,
    state: { background: location },
  })

  return (
    <Tr
      borderBottomWidth={1}
      borderColor="gray.300"
      bgColor="white"
      _last={{ borderBottomWidth: 0 }}
      minH={20}
    >
      <Td p={3}>
        <Popover variant="responsive" placement="bottom">
          <PopoverTrigger>
            <Flex cursor="pointer" align="center">
              <Box mr={3}>
                <GuestAvatar
                  firstName={firstName(name)}
                  lastName={lastName(name)}
                  photoUrl={photoUrl}
                />
              </Box>
              <Box lineHeight="none" noOfLines={2} mr={3}>
                <Text noOfLines={1}>{name}</Text>
                <Text noOfLines={1}>{email}</Text>
              </Box>
            </Flex>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverBody>
              <Text fontWeight="semibold" cursor="pointer" onClick={handleClickGuest}>Guest Profile</Text>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Td>
      <Td p={3}><Response response={response} /></Td>
    </Tr>
  )
}

export default ResponseListItem
